import { Chart as ChartJS, CategoryScale, LinearScale, Title, Tooltip, Legend, PointElement, LineElement } from "chart.js/auto";
import { unstable_HistoryRouter as HistoryRouter, Routes, Route } from "react-router";
import { Provider } from "react-redux";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";

import store from "@/state/store";
import { allRoutes, history } from "@/routing";
import { InitLayout } from "@/layouts";

ChartJS.register(CategoryScale, LinearScale, Title, Tooltip, Legend, PointElement, LineElement);

const queryClient = new QueryClient();

window.originalFetch = window.fetch;
window.fetch = function (resource, init) {
  const url = resource.url || resource;
  if (url.startsWith("http://localhost")) {
    return window.originalFetch(resource, Object.assign({ credentials: "include" }, init || {}));
  } else {
    return window.originalFetch(resource, init);
  }
};

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HistoryRouter history={history}>
        <Provider store={store}>
          <InitLayout>
            <Routes>
              {allRoutes.map((route) => (
                <Route exact={route.exact} path={route.path} element={route.component} key={route.path} />
              ))}
            </Routes>
          </InitLayout>
        </Provider>
      </HistoryRouter>
    </QueryClientProvider>
  );
};

export default App;
